export const visit = (vm, at) => {
vm(require("./availability/pl.lyaml"));
vm(require("./typical-response-time/pl.lyaml"));
vm(require("./default/pl.lyaml"));
at({ "pl": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "OK" } } });
};